import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const HighSchoolIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29737 8.2131L11.2974 2.28844C11.6869 1.90385 12.3131 1.90385 12.7026 2.28844L18.7026 8.2131C18.8929 8.40099 19 8.65725 19 8.92466V11H21C21.5523 11 22 11.4477 22 12V21C22 21.5523 21.5523 22 21 22H18H14H10H6H3C2.44772 22 2 21.5523 2 21V12C2 11.4477 2.44772 11 3 11H5V8.92466C5 8.65725 5.1071 8.40099 5.29737 8.2131ZM19 20V13H20V20H19ZM17 9.343V12V20H15V14C15 13.4477 14.5523 13 14 13H10C9.44772 13 9 13.4477 9 14V20H7V12V9.342L12 4.405L17 9.343ZM5 13H4V20H5V13ZM13 15V20H11V15H13ZM15 10.5C15 9.94772 14.5523 9.5 14 9.5H10C9.44772 9.5 9 9.94772 9 10.5C9 11.0523 9.44772 11.5 10 11.5H14C14.5523 11.5 15 11.0523 15 10.5Z"
            />
        </svg>
    );
};
